module.exports = __webpack_public_path__ + "media/mypage/images/icons/s_icon_pr_point-3a8059b34bcee3370188c7d55a5dfbde.png";